import { apiWarehouse } from './apiWarehouse'
import { apiExpectedDeliveries } from './apiExpectedDeliveries'
import { apiInboundBuffer } from './apiInboundBuffer'
import { apiMonitoring } from './apiMonitoring'

const apiWarehousee = {
	...apiWarehouse,
	...apiExpectedDeliveries,
	...apiInboundBuffer,
	...apiMonitoring,
}

export { apiExpectedDeliveries, apiInboundBuffer, apiMonitoring, apiWarehousee }
